import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getMe } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await getMe();
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const isSubscribed = user && ["active", "trialing", "comp"].includes(user.subscription_status);

  return (
    <AuthContext.Provider value={{ user, loading, isSubscribed, setUser, refresh }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
